"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _reactRedux = require("react-redux");
var _PayoutForm = _interopRequireDefault(require("./PayoutForm"));
var _TransactionsActions = require("../TransactionsActions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = (0, _BaseInjectors.injectToBaseCreationDialog)(_.flowRight((0, _reactRedux.connect)()), {
  createForm: _PayoutForm.default,
  title: 'Ajouter un compte bancaire',
  // Override handleSubmit of BaseCreationDialog
  handleSubmit: function handleSubmit(values) {
    var _this = this;
    this.dispatch({
      type: 'PAYOUT',
      data: values,
      onSuccess: function onSuccess() {
        _this.dispatch({
          type: 'FETCH_USER',
          params: {
            _embed: 'wallets'
          }
        });
        _this.dispatch({
          params: {
            _page: 1,
            _per_page: 10,
            _sort: '-service_transaction_id'
          },
          type: _TransactionsActions.FETCH_TRANSACTIONS_START
        });
      }
    });
    this.close();
  }
});
exports.default = _default;